//Reducers will return the data needed by our app
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import globalReducer from './globalReducer';
import reportsReducer from '../screens/Reports/reducer';
import loginReducer from '../screens/Login/reducer';
import customersReducer from '../screens/People/reducer';
//import suppliersReducer from "../screens/SuppliersContainer/reducer";
import dailyEntriesReducer from '../screens/DailyEntries/reducer';
//import { reducer as network } from 'react-native-offline';
//import {navReducer} from '../App';

export default combineReducers({
	globalReducer,
	form: formReducer,
	reportsReducer,
	loginReducer,
	customersReducer,
	//suppliersReducer,
	dailyEntriesReducer
	//network
	//nav: navReducer
});

/*
The names used to initialize Reducers in the combineReducers function will be used to reference
that particular Reducer anywhere in our App

*/
